import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import Paragraph from 'components/Paragraph';
import path from 'enums/path';
import classes from './SuccessStatus.module.scss';

const SuccessStatus = ({ children }) => (
  <div className={classes.success}>
    <div className={classes.successMessageContainer}>
      <FontAwesomeIcon icon={faCheck} size="4x" color="#84BE6A" />
      <Paragraph>{children}</Paragraph>
    </div>
    <div className={classes.successActionsContainer}>
      <a className="btn btn-light" href={path.Home}>
        Facturar de nuevo
      </a>
      <a className="btn btn-dark" href="https://epicland.com.mx/">
        Seguir comprando
      </a>
    </div>
  </div>
);

SuccessStatus.propTypes = {
  children: PropTypes.string.isRequired,
};

export default SuccessStatus;
